var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCookies } from "react-cookie";
import { CookieKeys, Expires } from "../constants/cookies";
import InstructionsModal from "./InstructionsModal";
import Button from "./Semantic/Button";
import SettingsModal from "./SettingsModal";
import styles from "../styles/NavBar.module.scss";
import ArchidektLogo from "./ArchidektLogo";
import StatsModal from "./DailyStats/StatsModal";
import { ReactComponent as Logo } from "../assets/logo.svg";
import { logAppEvent } from "../services/firebase.service";
var NavBar = function () {
    var _a = useCookies([CookieKeys.isDaily]), _cookies = _a[0], setCookies = _a[1];
    var handleRefresh = function () {
        logAppEvent("top_refresh_button");
        setCookies(CookieKeys.isDaily, "false", { maxAge: Expires.HOUR });
        window.location.reload();
    };
    return (_jsxs("div", __assign({ className: styles.navBarOuter }, { children: [_jsxs("div", __assign({ className: styles.navBarContainer }, { children: [_jsx("a", __assign({ href: "/", className: styles.logoContainer }, { children: _jsx(Logo, {}, void 0) }), void 0), _jsxs("div", __assign({ className: styles.buttons }, { children: [_jsx(InstructionsModal, {}, void 0), _jsx(StatsModal, {}, void 0), _jsx(Button, { icon: "shuffle", title: "Infinite Mode", onClick: handleRefresh }, void 0), _jsx(SettingsModal, {}, void 0)] }), void 0)] }), void 0), _jsxs("div", __assign({ className: styles.subtitle }, { children: [_jsx("div", { children: "Presented by\u00A0" }, void 0), " ", _jsx(ArchidektLogo, {}, void 0)] }), void 0)] }), void 0));
};
export default NavBar;
